<template>
	<v-card
		ref="card"
		v-resize="onResize"
		class="agent-card pa-0 d-block"
	>
		<section class="content">
			<v-skeleton-loader
				tile
				type="image"
				width="100%"
				:height="maxHeight"
			/>
			<div class="agentName px-3 py-2">
				<div class="red--text">
					<v-skeleton-loader
						type="text"
						width="60%"
					/>
				</div>
				<div>
					<v-skeleton-loader
						type="text"
						width="85%"
					/>
				</div>
				<div>
					<v-skeleton-loader
						type="text"
						width="80%"
					/>
				</div>
			</div>
			<div class="px-3 pb-3">
				<v-skeleton-loader
					type="text"
					width="100%"
				/>
			</div>
		</section>
		<div class="footer-content d-flex justify-center py-3">
			<v-skeleton-loader
				type="text"
				width="60%"
			/>
		</div>
	</v-card>
</template>

<script>

export default {
	data:() => ({
		maxHeight: '78%'
	}),

	methods: {
		onResize () {
			if (process.client) {
				this.$nextTick(() => {
					this.maxHeight = this.$refs['card'].$el.clientWidth * 0.78
				})
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.agent-card::v-deep {
	height: auto !important;
	background: none !important;
	border-radius: 0;
	box-shadow: 0px 0px 15px 3px rgba(0, 0, 0, 0.25);

	.v-btn__content {
		display: block;
	}
}
.content::v-deep {
	background: #fff;

	.agentName {
		box-sizing: border-box;
		min-height: 90px;
		max-height: 90px;

		div {
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	@media (max-width: 599px) {
		.agentLocation, .agentName {
			font-weight: bold;
			font-size: 1.2em;
		}
		.agentName div {
			max-width: unset;
		}
	}
}
.footer-content {
	background-color: #e9e9e9;
	font-size: 1rem;
}
</style>
